module.exports = __webpack_public_path__ + "../resources/img/ic_re_timeline_bar.4ee4bf7a.svg";